module.exports = "/images/vendor/desiigner-svg/svg/ui.svg?6c832123610493daedea0937aacd4533";